module.exports = __webpack_public_path__ + "img/avatar2.6b2eb1da.png";